/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cancel_fullscreen': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M354.133 682.667H256V640h170.667v170.667H384v-98.134l-140.8 140.8-29.867-29.866 140.8-140.8zm358.4 0l140.8 140.8-29.866 29.866-140.8-140.8v98.134H640V640h170.667v42.667h-98.134zM354.133 384l-140.8-140.8 29.867-29.867 140.8 140.8V256h42.667v170.667H256V384h98.133zm358.4 0h98.134v42.667H640V256h42.667v98.133l140.8-140.8 29.866 29.867-140.8 140.8z" _fill="#444"/>'
  }
})
